// ** React Imports
import { Link } from "react-router-dom";
// ** Third Party Components
import Proptypes from "prop-types";
// ** Reactstrap Imports
import { useTranslation } from "react-i18next";
import classnames from "classnames";

const BreadCrumbs = (props) => {
  // ** Props
  const currentTheme = localStorage.getItem("tuneIn_theme");
  const { breadCrumbTitle } = props;
  const { t } = useTranslation();
  return (
    <div
      className={classnames("indx_title_main_wrapper", {
        open: currentTheme == "#502D75",
      })}
    >
      <div className="container" style={{ maxWidth: "90%" }}>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="indx_title_left_wrapper">
              <h2>{breadCrumbTitle}</h2>
              <ul>
                <li>
                  <Link to="/">{t("Home")}&nbsp;&nbsp;&nbsp;/</Link>
                </li>
                <li>{breadCrumbTitle}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BreadCrumbs;

// ** PropTypes
BreadCrumbs.propTypes = {
  breadCrumbTitle: Proptypes.string.isRequired,
};
